export type ColorModeContrastPreference = "system" | "less" | "more";

export type ColorVisionDeficiencyPreference =
  | "none"
  | "red-green"
  | "tritanopia";

export type LegibilityFontPreference =
  | "default"
  | "open-dyslexic"
  | "atkinson-hyperlegible";

export type UserAccessibilityPreferencesPayload = {
  color_mode_contrast?: ColorModeContrastPreference;
  color_vision_deficiency?: ColorVisionDeficiencyPreference;
  legibility_font?: LegibilityFontPreference;
};

export const COLOR_MODE_CONTRAST_OPTIONS: readonly ColorModeContrastPreference[] =
  ["system", "less", "more"];

export const COLOR_VISION_DEFICIENCY_OPTIONS: readonly ColorVisionDeficiencyPreference[] =
  ["none", "red-green", "tritanopia"];

export const LEGIBILITY_FONT_OPTIONS: readonly LegibilityFontPreference[] = [
  "default",
  "atkinson-hyperlegible",
  "open-dyslexic",
];

/**
 * Fallback values for every accessibility axis. Mirrors the backend's
 * `UserAccessibilityPreferences.default_preferences()`. Used to seed optimistic
 * updates so setting one axis never drops the others.
 */
export const DEFAULT_ACCESSIBILITY_PREFERENCES = {
  color_mode_contrast: "system",
  color_vision_deficiency: "none",
  legibility_font: "default",
} as const satisfies Required<UserAccessibilityPreferencesPayload>;
